
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { ProgressBar } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Progress Bar`}</h1>
<p>{`Used to display loading of uploads, or other elements that require the user to know the amount ot loading left.
The component takes the full width of the parent container.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ProgressBar } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ProgressBar />`} component={ProgressBar} mdxType="Playground">
  <ProgressBar mdxType="ProgressBar" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;